module.exports = __webpack_public_path__ + "img/210-Blanc Papyrus.jpg";